class Color {

    static BLACK = "#000000";

    static WHITE = "#ffffff";

    static LIGHT_RED = "#ff0000";

    static RED = "#e80000";

    static DARK_RED = "#b90000";

    static DISABLED_BLUE = "#9dc8e2";

    static BLUE = "#006cbe";

    static GREEN = "#008000";

    static YELLOW = "#ffa500";

    static GREY = "#808080";

    static DISABLED_GREY="#c8c8c8";

    static ORANGE = "#ffa400";

}

export default Color;